import { render, staticRenderFns } from "./gsm.vue?vue&type=template&id=4f63e90e"
import script from "./gsm.vue?vue&type=script&lang=js"
export * from "./gsm.vue?vue&type=script&lang=js"
import style0 from "./gsm.vue?vue&type=style&index=0&id=4f63e90e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports